import { render, staticRenderFns } from "./Gauche.vue?vue&type=template&id=82881f70&"
import script from "./Gauche.vue?vue&type=script&lang=js&"
export * from "./Gauche.vue?vue&type=script&lang=js&"
import style0 from "./Gauche.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports